import { getSpacesObjectURL, SPACES_PUBLIC_URL } from '../config/storage';

export function fetchImage(photoURL) {
  if (typeof photoURL !== "string" || !photoURL) return null;

  try {
    const parsed = new URL(photoURL);
    if (parsed.hostname.endsWith('.amazonaws.com')) {
      return getSpacesObjectURL(parsed.pathname);
    }
  } catch (error) {
    // Continue handling normal object keys and URLs below.
  }

  if (
    /^(?:https?:)?\/\//i.test(photoURL) ||
    photoURL.startsWith("data:") ||
    photoURL.startsWith("blob:") ||
    photoURL.startsWith("file:") ||
    photoURL.startsWith("/")
  ) {
    if (!photoURL.startsWith(`${process.env.REACT_APP_BACKEND_URL}/images/`)) {
      if (SPACES_PUBLIC_URL && photoURL.startsWith(`${SPACES_PUBLIC_URL}/`)) {
        return getSpacesObjectURL(photoURL.slice(`${SPACES_PUBLIC_URL}/`.length));
      }
      return photoURL;
    }
  }

  if (photoURL?.startsWith(`${process.env.REACT_APP_BACKEND_URL}/images/`)  ) {
    photoURL = photoURL.split('/images/')[1];
    return getSpacesObjectURL(photoURL)
  } else if (SPACES_PUBLIC_URL && photoURL.startsWith(`${SPACES_PUBLIC_URL}/`)) {
    return photoURL
  }
  return photoURL ? getSpacesObjectURL(photoURL) : null;
}


export function processPhotoURL(photoURL) {
  if (
    typeof photoURL === 'string' && ( photoURL.startsWith(`${process.env.REACT_APP_BACKEND_URL}/images`) || (SPACES_PUBLIC_URL && photoURL.startsWith(`${SPACES_PUBLIC_URL}/`)) ) &&
    !photoURL.startsWith('file://')
  ) {
    let photoId = photoURL.split('/').pop();
    return photoId;
  }
  return photoURL;
}